import Layout from "./Layout";

import module from "Schedules/AddActivityRow";
import rootSaga from "Schedules/AddActivityRow/sagas";

module.setRootSaga(rootSaga);

export default Layout;
